import { render, staticRenderFns } from "./copyrightRegistrationBHBJ.vue?vue&type=template&id=740cd444&scoped=true&"
import script from "./copyrightRegistrationBHBJ.vue?vue&type=script&lang=js&"
export * from "./copyrightRegistrationBHBJ.vue?vue&type=script&lang=js&"
import style0 from "./copyrightRegistrationBHBJ.vue?vue&type=style&index=0&lang=less&"
import style1 from "./copyrightRegistrationBHBJ.vue?vue&type=style&index=1&id=740cd444&lang=less&scoped=true&"
import style2 from "./copyrightRegistrationBHBJ.vue?vue&type=style&index=2&id=740cd444&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "740cd444",
  null
  
)

export default component.exports